import type { ReactNode } from 'react';
import { Image } from '@/components/ui/Image';

type WorkspaceFlowShellProps = {
  children: ReactNode;
};

export function WorkspaceFlowShell({ children }: WorkspaceFlowShellProps) {
  return (
    <main
      data-testid="workspace-flow-shell"
      className="relative flex min-h-screen items-center justify-center overflow-hidden bg-background bg-[linear-gradient(135deg,#b9d2ff_0%,#c8dcff_42%,#aab8ff_100%)] p-4 sm:p-8"
    >
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 overflow-hidden">
        <div className="absolute -left-56 -top-56 h-[38rem] w-[38rem] rounded-full bg-blue-200/70" />
        <div className="absolute -right-48 top-[18%] h-[34rem] w-[34rem] rounded-full bg-indigo-400/45 blur-sm" />
        <div className="absolute -bottom-[24rem] left-[22%] h-[42rem] w-[60rem] rounded-[50%] bg-indigo-500/45 blur-sm" />
        <div className="absolute inset-0 opacity-40 [background-image:radial-gradient(rgba(37,99,235,0.28)_1px,transparent_1px)] [background-size:24px_24px]" />
        <div className="absolute -bottom-20 -left-12 h-64 w-64 rounded-[40%] border border-white/40" />
        <div className="absolute -right-16 top-16 h-72 w-72 rounded-full border border-white/30" />
      </div>

      <div className="relative z-10 w-full max-w-2xl">{children}</div>
    </main>
  );
}

export function WorkspaceFlowBrand() {
  return (
    <div className="mb-9 flex items-center justify-center gap-3 text-xl font-semibold tracking-tight text-slate-950">
      <Image
        src="/logo-icon.png"
        alt=""
        width={48}
        height={48}
        priority
        className="h-12 w-12 rounded-2xl shadow-sm"
      />
      <span>Day Sheetly</span>
    </div>
  );
}
